import React from 'react';
import TextWithUpArrow from '../../../text-with-up-arrow';
import CheckBox from '../../../check-box';
import Badge from '../../../badge';
import { renderAsHtml } from '../../../../app-actions';
import TextWithTooltip from '../../../text-with-tooltip';

const RecommendedProductHeaderView = (props) => {
  const { productData, authorableContent } = props;
  const { accordionHeading, tooltips } = authorableContent;
  const {
    marketPercentageMobile,
    increasedPercentageMobile,
    marketPercentageToolTip,
    increasedPercentageToolTip,
  } = accordionHeading;
  const { updateProductRecommendation } = props.actions;
  const {
    recommendedProductCode,
    recommendedProductName,
    recommendedProductSummary,
    marketComparisonPercentage = 0,
    optimizationPercentage = 0,
    recommendationCode,
    recommendationSelected,
  } = productData;
  const onClickCheckBox = (checkBoxState) => {
    const data = { cidn: props.cidn, checkBoxState };
    updateProductRecommendation(data);
  };
  const productDescriptionAsHtml = renderAsHtml(recommendedProductSummary);
  const valueBoxClasses = `
    col-3
    text-center
    d-flex 
    flex-row
    justify-content-center
    justify-content-sm-center
    align-self-center
    align-self-sm-start
  `;
  return (
    <div className="row recommended-product-header d-flex">
      <div className="col-sm-5 col-9 header-title">
        <div id={`product-name-${recommendedProductCode}`} className="product-name">
          {recommendedProductName}
          {recommendationCode && <Badge tooltip={tooltips[recommendationCode]} id={`tooltiptext-${recommendedProductCode}`} />}
        </div>
        <div className="product-description">
          {productDescriptionAsHtml}
        </div>
      </div>
      <div className="product-checkbox col-sm-2 col-3 pl-sm-3 text-center d-flex d-sm-block flex-row justify-content-center">
        <CheckBox
          id={recommendedProductCode}
          checked={recommendationSelected}
          callBackAction={onClickCheckBox}
        />
      </div>

      <div className="market-comparison-percentage-value d-sm-none col-8">
        <TextWithTooltip
          labelText={marketPercentageMobile}
          text={<i className="td-icon icon-help" />}
          textClassName="help-icon-container"
          toolTipText={marketPercentageToolTip}
          id={`${recommendedProductCode}-market-comparison-percentage-value`}
        />
      </div>
      <div className={`col-sm-2 d-sm-block ${valueBoxClasses}`}>
        <div id={`product-name-${recommendedProductCode}-market-percentage`} className="comparison-percentage-value value-container">
          {marketComparisonPercentage > 0 ? `${marketComparisonPercentage}%` : <div className="empty-value" />}
        </div>
      </div>
      <div className="increased-percentage-value d-sm-none col-8">
        <TextWithTooltip
          labelText={increasedPercentageMobile}
          text={<i className="td-icon icon-help" />}
          textClassName="help-icon-container"
          toolTipText={increasedPercentageToolTip}
          id={`${recommendedProductCode}-increased-percentage-value`}
        />
      </div>
      <div className={`optimization-percentage-value col-3 col-sm-3  ${valueBoxClasses} ${optimizationPercentage > 0 ? 'px-0 pl-sm-3' : 'pr-3'}`} >
        {optimizationPercentage > 0 ? <TextWithUpArrow
          id={`product-name-${recommendedProductCode}-increased-percentage`}
          text={`${optimizationPercentage}%`}
        /> : <div className="empty-value" />}
      </div>
    </div>);
};

export default RecommendedProductHeaderView;
